import React from "react"

import { type IconProps } from "./utils"

export default function EyeOpen(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99997 5.00016C7.39412 5.00018 4.69422 6.49249 2.8015 9.67204C2.68129 9.87397 2.68129 10.1264 2.8015 10.3284C4.69422 13.5079 7.39411 15.0002 9.99995 15.0002C12.6058 15.0001 15.3057 13.5078 17.1984 10.3283C17.3186 10.1264 17.3186 9.87388 17.1984 9.67195C15.3057 6.49242 12.6058 5.00014 9.99997 5.00016ZM9.99996 3.3335C13.2931 3.33347 16.4921 5.2271 18.6306 8.81943C19.0635 9.54669 19.0635 10.4535 18.6306 11.1808C16.4921 14.7731 13.2931 16.6668 9.99997 16.6668C6.70687 16.6669 3.50782 14.7732 1.36937 11.1809C0.936447 10.4536 0.936448 9.54678 1.36937 8.81952C3.50782 5.22719 6.70686 3.33352 9.99996 3.3335ZM9.99996 8.3335C9.07949 8.3335 8.33329 9.07969 8.33329 10.0002C8.33329 10.9206 9.07949 11.6668 9.99996 11.6668C10.9204 11.6668 11.6666 10.9206 11.6666 10.0002C11.6666 9.07969 10.9204 8.3335 9.99996 8.3335ZM6.66663 10.0002C6.66663 8.15921 8.15901 6.66683 9.99996 6.66683C11.8409 6.66683 13.3333 8.15921 13.3333 10.0002C13.3333 11.8411 11.8409 13.3335 9.99996 13.3335C8.15901 13.3335 6.66663 11.8411 6.66663 10.0002Z"
        fill="currentColor"
      />
    </svg>
  )
}
